import React, { useContext, useEffect, useState, useCallback } from 'react';
import { TableContext } from '../../../contexts/tableContext';
import useRouteDrawing from './hooks/useRouteDrawing';
import RouteMap from './components/RouteMap';
import RouteInfoPanel from './components/RouteInfoPanel';
import styles from './CreateRoute.module.scss';

const CreateRoute = () => {
  const {
    settingscreaterouteSetStyle,
    settingsgeneralSetStyle,
    settingsprofileSetStyle,
    settingschangepassSetStyle,
    settingsapiSetStyle,
    settingsprefSetStyle,
    setDashboardHeader,
    formthemeStyle,
  } = useContext(TableContext);

  useEffect(() => {
    setDashboardHeader('Settings');
    settingscreaterouteSetStyle('settingsgeneral');
    settingsgeneralSetStyle('settingslinks');
    settingsprofileSetStyle('settingslinks');
    settingschangepassSetStyle('settingslinks');
    settingsapiSetStyle('settingslinks');
    settingsprefSetStyle('settingslinks');
  }, [
    setDashboardHeader,
    settingscreaterouteSetStyle,
    settingsgeneralSetStyle,
    settingsprofileSetStyle,
    settingschangepassSetStyle,
    settingsapiSetStyle,
    settingsprefSetStyle,
  ]);

  const {
    waypoints,
    waypointLabels,
    drawFromIndex,
    routeName,
    setRouteName,
    routeDescription,
    setRouteDescription,
    selectedIndex,
    savedRoutes,
    editingRouteId,
    isLoadingRoutes,
    isSaving,
    totalDistanceKm,
    geoJson,
    routeMapFocus,
    handleMapClick,
    handleWaypointDrag,
    handleDeleteWaypoint,
    handleInsertWaypoint,
    handleSelectWaypoint,
    handleSetDrawFrom,
    handleCancelDrawFrom,
    handleNewRoute,
    handleBranchFromStop,
    handleSwitchToRoute,
    handleRemoveCanvasRoute,
    activeRouteColor,
    canvasRoutes,
    handleSetWaypointLabel,
    handleUpdateWaypointCoord,
    handleMoveWaypoint,
    handleAddStop,
    generatedCoordinates,
    isGenerating,
    isRouteStale,
    routeProfile,
    setRouteProfile,
    handleGenerateRoute,
    handleClearGeneratedRoute,
    handleClearRoute,
    handleSaveRoute,
    handleLoadRoutes,
    handleLoadRoute,
    handleDeleteSavedRoute,
  } = useRouteDrawing();

  // flyToCoord — set by panel's stop-search; watched by RouteMap to trigger flyTo
  const [flyToCoord, setFlyToCoord] = useState(null);

  // Location finder markers — independent of route waypoints, purely visual
  const [startMarker, setStartMarker] = useState(null);
  const [destMarker, setDestMarker]   = useState(null);

  const handleStartMarkerDrag = useCallback((coord) => {
    setStartMarker(coord);
  }, []);

  const handleDestMarkerDrag = useCallback((coord) => {
    setDestMarker(coord);
  }, []);

  return (
    <div className={`${styles.pageWrapper} ${styles[formthemeStyle]}`}>
      <div className={styles.pageHeader}>
        <div className={styles.headerLeft}>
          <h5 className={styles.pageTitle}>
            {editingRouteId ? 'Edit Route' : 'Create Route'}
          </h5>
          <p className={styles.pageSubtitle}>
            Search for stops, click the map to place waypoints, or drag markers to refine your route
          </p>
        </div>
      </div>

      <div className={styles.workspace}>
        <RouteMap
          waypoints={waypoints}
          waypointLabels={waypointLabels}
          selectedIndex={selectedIndex}
          drawFromIndex={drawFromIndex}
          activeRouteColor={activeRouteColor}
          canvasRoutes={canvasRoutes}
          geoJson={geoJson}
          flyToCoord={flyToCoord}
          routeMapFocus={routeMapFocus}
          isRouteGenerated={!!generatedCoordinates}
          onMapClick={handleMapClick}
          onInsertWaypoint={handleInsertWaypoint}
          onWaypointDrag={handleWaypointDrag}
          onWaypointClick={handleSelectWaypoint}
          onCancelDrawFrom={handleCancelDrawFrom}
          startMarker={startMarker}
          destMarker={destMarker}
          onStartMarkerDrag={handleStartMarkerDrag}
          onDestMarkerDrag={handleDestMarkerDrag}
        />

        <RouteInfoPanel
          routeName={routeName}
          setRouteName={setRouteName}
          routeDescription={routeDescription}
          setRouteDescription={setRouteDescription}
          waypoints={waypoints}
          waypointLabels={waypointLabels}
          selectedIndex={selectedIndex}
          drawFromIndex={drawFromIndex}
          totalDistanceKm={totalDistanceKm}
          isSaving={isSaving}
          isLoadingRoutes={isLoadingRoutes}
          savedRoutes={savedRoutes}
          editingRouteId={editingRouteId}
          generatedCoordinates={generatedCoordinates}
          isGenerating={isGenerating}
          isRouteStale={isRouteStale}
          routeProfile={routeProfile}
          setRouteProfile={setRouteProfile}
          onGenerateRoute={handleGenerateRoute}
          onClearGeneratedRoute={handleClearGeneratedRoute}
          onSave={handleSaveRoute}
          onClear={handleClearRoute}
          onLoadRoutes={handleLoadRoutes}
          onLoadRoute={handleLoadRoute}
          onDeleteRoute={handleDeleteSavedRoute}
          onDeleteWaypoint={handleDeleteWaypoint}
          onSelectWaypoint={handleSelectWaypoint}
          onSetWaypointLabel={handleSetWaypointLabel}
          onUpdateWaypointCoord={handleUpdateWaypointCoord}
          onMoveWaypoint={handleMoveWaypoint}
          onAddStop={handleAddStop}
          onFlyTo={setFlyToCoord}
          onStartMarker={setStartMarker}
          onDestMarker={setDestMarker}
          startMarker={startMarker}
          destMarker={destMarker}
          onSetDrawFrom={handleSetDrawFrom}
          activeRouteColor={activeRouteColor}
          canvasRoutes={canvasRoutes}
          onNewRoute={handleNewRoute}
          onBranchFromStop={handleBranchFromStop}
          onSwitchToRoute={handleSwitchToRoute}
          onRemoveCanvasRoute={handleRemoveCanvasRoute}
        />
      </div>
    </div>
  );
};

export default CreateRoute;
